/** Corps POST `/api/dashboard/data` — aligné sur `fetchDashboardData`. */
export function buildDashboardDataBody({
  view,
  entityId,
  roleId,
  startDate,
  endDate,
  chartYear,
  chartMonth,
  chartGranularity = "month",
  comparisonMode = "previous_month",
  topLimit = 6,
}) {
  return {
    view,
    entityId,
    roleId,
    startDate,
    endDate,
    chartGranularity,
    chartYear,
    chartMonth,
    comparisonMode,
    topLimit,
  };
}
